import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvanoTableHeaderCheckboxModule } from './avano-table-header-checkbox/avano-table-header-checkbox.module';

@NgModule({
  imports: [CommonModule],
  exports: [
    AvanoTableHeaderCheckboxModule,
  ],
  declarations: []
})
export class AvanoPrimengWrapperModule {}
